import { generateUUID } from '@thoughtspot/js-util';
import React, { useEffect, useRef, useState } from 'react';
import { Checkbox } from '../../../../checkbox';
import styles from './header-checkbox-cell.module.scss';
export const HeaderCheckboxCell = ({ api, }) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isIndeterminte, setIsIndeterminate] = useState(false);
    const isFirstLoad = useRef(true);
    const toggleSelection = (e) => {
        if (e.target.checked) {
            api.selectAll();
        }
        else {
            api.deselectAll();
        }
    };
    useEffect(() => {
        const listener = () => {
            let readOnly = 0;
            for (let i = 0; i < api.getDisplayedRowCount(); i++) {
                const currentNode = api.getDisplayedRowAtIndex(i);
                if (currentNode === null || currentNode === void 0 ? void 0 : currentNode.data.readOnly) {
                    readOnly += 1;
                }
            }
            let selectedDisplayRowsCount = 0;
            const numberOfRows = api.getDisplayedRowCount();
            const selectedNodes = api.getSelectedNodes() || [];
            selectedNodes.forEach((node) => {
                if (node.displayed) {
                    selectedDisplayRowsCount += 1;
                }
            });
            const selectableRowsCount = numberOfRows - readOnly;
            const checked = !!numberOfRows &&
                selectableRowsCount > 0 &&
                selectedDisplayRowsCount === selectableRowsCount;
            const indeterminate = !!selectedDisplayRowsCount &&
                selectedDisplayRowsCount < selectableRowsCount;
            setIsChecked(checked);
            setIsIndeterminate(indeterminate);
        };
        // If we have pre-selected rows, the header checkbox cell doesn't get set
        // Hence, we need to call the listener method on first load
        if (isFirstLoad.current) {
            listener();
            isFirstLoad.current = false;
        }
        api.addEventListener('selectionChanged', listener);
        api.addEventListener('rowDataChanged', listener);
        return () => {
            api.removeEventListener('selectionChanged', listener);
            api.removeEventListener('rowDataChanged', listener);
        };
    }, [api]);
    return (React.createElement("div", { className: styles.headerCheckboxContainer },
        React.createElement(Checkbox, { id: generateUUID(), label: "", hideLabel: true, checked: isChecked, indeterminate: isIndeterminte, onChange: toggleSelection, ariaLabel: "checkbox" })));
};
//# sourceMappingURL=header-checkbox-cell.js.map